import { apiConstants } from "@data/constants/apiConstants"
import { staticDataService } from "@data/services/staticDataService"

// The read in flight, shared: two login screens mounting together send one request, not two.
let pending = null

/**
 * Reads, without an account, what the backend serves before login (`GET static-data/login`) and
 * keeps it in `staticData` (persisted): the OTA-at-launch switch (`apply_update_on_launch`,
 * `featureFlags/launchUpdateFF`), which a logged-out device reads nowhere else. Every login
 * screen asks for it on mount (`featureFlags/screenBridge` · `loginScreen`). A failure changes
 * nothing: the last answer read stays.
 */
export const refreshLoginStaticData = () => (dispatch) => {
    if (pending == null) {
        pending = staticDataService
            .getLoginStaticData()
            .then((response) => response?.data?.data)
            .finally(() => {
                pending = null
            })
    }
    return pending
        .then((data) =>
            dispatch({
                type:
                    staticDataService.getLoginStaticData.name +
                    apiConstants._SUCCESS,
                data,
            })
        )
        .catch(() => {})
}
